"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnButton = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const ViewColumn_1 = __importDefault(require("@material-ui/icons/ViewColumn"));
const table_field_toolbar_button_1 = require("../table-field-toolbar-button");
// TODO
function ColumnButton() {
    return (react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_TOOLBAR_BTN_COLUMN_DIALOG_OPEN", defaultMessage: "Nastaven\u00ED sloupc\u016F" }), onClick: () => ({}), IconComponent: ViewColumn_1.default, disabled: false, show: true }));
}
exports.ColumnButton = ColumnButton;
//# sourceMappingURL=column-button.js.map